<template xmlns:v-on="http://www.w3.org/1999/xhtml">
    <div class="canvas-panel" style="left:0;">
        <v-layout right>
            <opengraph ref="opengraph"
                       :width=100000 :height=100000
                       :sliderLocationScale=sliderLocationScale
                       focus-canvas-on-select wheelScalable :labelEditable="true"
                       :dragPageMovable="dragPageMovable" :enableContextmenu="false" :enableRootContextmenu="false"
                       :enableHotkeyCtrlC="false" :enableHotkeyCtrlV="false"
                       :enableHotkeyDelete="false" :enableHotkeyCtrlZ="false" :enableHotkeyCtrlD="false"
                       :enableHotkeyCtrlG="false" :slider="true" :movable="!readOnly" :resizable="!readOnly"
                       :selectable="true"
                       :connectable="!readOnly" v-if="value"
                       :autoSliderUpdate="true"
                       :imageBase="imageBase"
            >

                <div v-if="value.elements &&  typeof value.elements == 'object'"
                     v-for="elementId in Object.keys(value.elements)">
                    <component
                            v-if="elementId && value.elements[elementId]"
                            :is="getComponentByClassName(value.elements[elementId]._type)"
                            :value.sync="value.elements[elementId]"
                            :ref="elementId"
                    ></component>
                </div>

                <div v-if="value.relations && typeof value.relations == 'object'"
                     v-for="relationId in Object.keys(value.relations)">
                    <component
                            v-if="relationId && value.relations[relationId]"
                            :is="getComponentByClassName(value.relations[relationId]._type)"
                            :value.sync="value.relations[relationId]"
                            :ref="relationId"
                    ></component>
                </div>
            </opengraph>

            <v-layout row style="width: -webkit-fill-available">
                <v-row align="start" justify="end" style="margin-left: 65%; margin-right: 20%;">
                    <v-text-field
                            disabled
                            v-model="projectName"
                            label="Project Name"
                    >
                    </v-text-field>
                </v-row>
            </v-layout>


            <v-footer absolute >
                <v-slider
                        v-model="slider.sliderIndex"
                        :max="slider.sliderSize"
                        thumb-label
                        step="1"
                        ticks="always"
                        tick-size="10"
                        tick-color="black"
                >
                    <template v-slot:thumb-label="{ value }"  >
                        <v-img
                                :src="slider.sliderLists && slider.sliderLists[slider.sliderIndex] ? slider.sliderLists[slider.sliderIndex].img: null"
                                max-width="200px"
                                max-height="200px"
                        ></v-img>
                    </template>
                </v-slider>
            </v-footer>

        </v-layout>
        <v-layout>
            <replay-panel
                    v-model="value"
                    :startQueueKey="queue.startQueueKey"
                    :endQueueKey="queue.endQueueKey"
                    :sliderLists="slider.sliderLists"
                    :sliderIndex="slider.sliderIndex"
                    :sliderSize="slider.sliderSize"
                    @nextSnap="nextSnap"
                    @prevSnap="prevSnap"
            ></replay-panel>
        </v-layout>

    </div>
</template>

<script>
    import ModelReplay from "../modeling/ModelReplay";

    var jp = require('jsonpath');

    export default {
        name: 'event-storming-model-replay',
        props: {},
        mixins: [ModelReplay],
        data() {
            return {
                elementTypes: [
                    {
                        'icon': 'bpmn-icon-start-event-none',//'OG.shape.essencia.Alpha',
                        'component': 'domain-event-definition',
                        'label': 'Event',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/event.png`
                    },
                    {
                        'icon': 'bpmn-icon-start-event-none',//'OG.shape.essencia.Alpha',
                        'component': 'command-definition',
                        'label': 'Command',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/command.png`
                    },
                    {
                        'icon': 'bpmn-icon-start-event-none',//'OG.shape.essencia.Alpha',
                        'component': 'policy-definition',
                        'label': 'Policy',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/policy.png`
                    },
                    {
                        'icon': 'bpmn-icon-start-event-none',//'OG.shape.essencia.Alpha',
                        'component': 'aggregate-definition',
                        'label': 'Aggregate',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/aggregate.png`
                    },
                    {
                        'icon': 'bpmn-icon-start-event-none',//'OG.shape.essencia.Alpha',
                        'component': 'external-definition',
                        'label': 'External',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/external.png`

                    },
                    {
                        'icon': 'bpmn-icon-start-event-none',//'OG.shape.essencia.Alpha',
                        'component': 'view-definition',
                        'label': 'View',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/view.png`

                    },
                    {
                        'icon': 'bpmn-icon-start-event-none',//'OG.shape.essencia.Alpha',
                        'component': 'bounded-context-definition',
                        'label': 'Bounded Context',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/bounded2.png`

                    },
                    {
                        'icon': 'bpmn-icon-start-actor-none',//'OG.shape.essencia.Alpha',
                        'component': 'actor-definition',
                        'label': 'Actor',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/actor.png`
                    },
                ],
            }
        },
        created: function () {
            this.canvasType = 'es'
        },
        mounted() {
            // document.getElementById("sliders").addEventListener("mouseover", function (newVal) {
            //     console.log(newVal)
            // });
        },
        computed: {},
        watch: {},
        methods: {
            test(newVal) {
                var me = this
                console.log('test', newVal)
                return me.slider.sliderLists && me.slider.sliderLists[me.slider.sliderIndex] ? me.slider.sliderLists[me.slider.sliderIndex].img : null
            },
            getComponentByClassName: function (className) {
                var componentByClassName;
                $.each(window.Vue.eventStormingModelingComponents, function (i, component) {
                    if (component.default.computed && component.default.computed.className && component.default.computed.className() == className) {
                        componentByClassName = component.default;
                    }
                });
                return componentByClassName;
            },
        }
    }
</script>


<style scoped lang="css" rel="stylesheet/css">
    .canvas-panel {
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        position: absolute;
        overflow: hidden;
    }
</style>

